import { useEffect, useState } from 'react';
import { getCity, getType, getProgram, getClass } from '../services/services';

export function useEnrollmentApiData ( cityId, learningType, programId ) {
    const [cityList, setCityList] = useState( [] );
    const [learningTypeList, setLearningTypeList] = useState( [] );
    const [programList, setProgramList] = useState( [] );
    const [classMeetList, setClassMeetList] = useState( [] );

    useEffect( () => {
        let cancelled = false;
        getCity()
            .then( ( data ) => {
                if ( !cancelled ) setCityList( data || [] );
            } )
            .catch( ( e ) => console.error( 'Gagal mengambil data kota:', e ) );
        return () => {
            cancelled = true;
        };
    }, [] );

    useEffect( () => {
        if ( !cityId ) {
            setLearningTypeList( [] );
            return;
        }
        console.log('Calling getType with:', cityId);
        let cancelled = false;
        getType( cityId )
            .then( ( data ) => {
                if ( !cancelled ) setLearningTypeList( data || [] );
            } )
            .catch( ( e ) => console.error( 'Gagal memuat data pembelajaran:', e ) );
        return () => {
            cancelled = true;
        };
    }, [cityId] );

    useEffect( () => {
        if ( !cityId || !learningType ) {
            setProgramList( [] );
            return;
        }
        let cancelled = false;
        getProgram( cityId, learningType )
            .then( ( data ) => {
                if ( !cancelled ) setProgramList( data || [] );
            } )
            .catch( ( e ) => console.error( 'Gagal memuat data program:', e ) );
        return () => {
            cancelled = true;
        };
    }, [cityId, learningType] );

    useEffect( () => {
        if ( !cityId || !learningType || !programId ) {
            setClassMeetList( [] );
            return;
        }
        let cancelled = false;
        getClass( cityId, learningType, programId )
            .then( ( data ) => {
                if ( !cancelled ) setClassMeetList( data || [] );
            } )
            .catch( ( e ) => console.error( 'Gagal memuat data jumlah pertemuan:', e ) );
        return () => {
            cancelled = true;
        };
    }, [cityId, learningType, programId] );

    return { cityList, learningTypeList, programList, classMeetList };
}
